<div class="main-container">
  <div class="row content-area">
    <mat-card class="col-2 filter-tab">
      <mat-card-content>
        <div>
          <div matTooltip="Read Only Mode" [matTooltipDisabled]="!activeUser.getValue().limited">
            <button mat-raised-button color="primary" class="btn-block actionBtns"
                    [disabled]="activeUser.getValue().limited" (click)="newTicket()">New Ticket
            </button>
          </div>
          <button mat-raised-button
                  *ngIf="!activeUser.getValue().limited"
                  color="accent"
                  class="btn-block actionBtns"
                  (click)="router.navigate(['/high-risk-security'])">
            Mobicint High Risk Authentication
          </button>
        </div>
        <div class="row">
          <div class="col">
            <mat-accordion displayMode="flat" hideToggle>
              <mat-form-field class="search-input w-100">
                <mat-label>Search Tickets</mat-label>
                <input #input type="search" matInput class="search-ticket-input"
                       placeholder="Search Tickets..." autocomplete="nope" />
                <button *ngIf="input.value" matSuffix mat-icon-button (click)="input.value = ''; applyFilter()">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>

              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Date Range</mat-label>
                <mat-date-range-input [rangePicker]="picker">
                  <input matStartDate placeholder="From date" [(ngModel)]="createdByFromDate">
                  <input matEndDate placeholder="To date" [(ngModel)]="createdByToDate" (ngModelChange)="applyFilter()">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
              </mat-form-field>

              <button mat-raised-button color="primary"
                      class="btn-block actionBtns"
                      [disabled]="!createdByFromDate || !createdByToDate"
                      (click)="createdByToDate = null; createdByFromDate = null">Clear Dates
              </button>

              <div *ngIf="canChangeCUID" class="change-cuid-container">
                <mat-form-field appearance="outline" class="tickets-by-cuid">
                  <mat-label>Search CUID</mat-label>
                  <input class="cuid-input"
                         type="text"
                         matInput
                         placeholder="Search CUID"
                         [formControl]="cuidSearch"
                         [matAutocomplete]="cuidList"
                         (keyup.enter)="getTickets($event.target.value)">
                  <mat-autocomplete autoActiveFirstOption #cuidList="matAutocomplete">
                    <mat-option class="cuid-options"
                                *ngFor="let cu of creditUnionsSearch | async"
                                (onSelectionChange)="getTickets(cu.cuid)"
                                [value]="cu.cuid">{{cu.cuid}} - {{cu.name}}</mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
              <button mat-raised-button color="primary" class="export-ticket-table" (click)="exportTable()">Export
                Table
              </button>
              <mat-expansion-panel [disabled]="true" [expanded]="true" class="toggle-btn-container">
                <mat-expansion-panel-header>
                  <mat-panel-title class="text-center">Filter Options</mat-panel-title>
                </mat-expansion-panel-header>
                <div class="checkbox-group row">
                  <!--                                    TODO: WORKING ON FILTERING NOW STILL NEED TO TEST THE TICKET METHODS-->
                  <mat-checkbox class="filter-checkbox col-12"
                                [checked]="allCheckBoxSelected()"
                                (change)="clearCheckbox()"
                  >All
                  </mat-checkbox>
                  <hr class="col-lg-12">
                  <p class="text-muted col-lg-12">Status</p>
                  <div class="filter-checkbox col-12" *ngFor="let status of statusFilters; let i = index">
                    <mat-checkbox *ngIf="i !== 3"
                                  [checked]="status.include"
                                  (change)="updateFilters($event, status)">
                      {{status.label}}
                    </mat-checkbox>
                  </div>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card class="col-10">
      <mat-card-header>
        <mat-card-title class="col-6">Tickets</mat-card-title>
        <button mat-icon-button color="secondary" class="refreshBtn"><i class="fas fa-sync-alt fa-lg"></i></button>
      </mat-card-header>
      <mat-card-content>
        <table mat-table class="table-striped" [dataSource]="ticketsService.tickets" matSort
               matSortActive="ticketNumber" matSortDirection="desc" matSortDisableClear>

          <ng-container matColumnDef="ticketNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Ticket</th>
            <td mat-cell *matCellDef="let ticket">{{ticket.ticketNumber}}</td>
          </ng-container>

          <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Title</th>
            <td mat-cell *matCellDef="let ticket">{{ticket.title}}</td>
          </ng-container>

          <ng-container matColumnDef="requestedBy">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Requested By</th>
            <td mat-cell *matCellDef="let ticket">{{ticket.contact}}</td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let ticket">{{ticket.status | ticketStatus: 'status'}}</td>
          </ng-container>

          <ng-container matColumnDef="createdTime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Created</th>
            <td mat-cell *matCellDef="let ticket">{{ticket.createdTime | displayDate: 'Created' : dateColumn}}</td>
          </ng-container>

          <ng-container matColumnDef="lastUpdated">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Update</th>
            <td mat-cell *matCellDef="let ticket">{{ticket.lastUpdated | displayDate: 'Last Updated' : dateColumn}}</td>
          </ng-container>

          <ng-container matColumnDef="supportRep">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Support Rep</th>
            <td mat-cell
                *matCellDef="let ticket">{{ticket.supportRepresentative | toName: (allPortalUsers | async)}}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="columns"></tr>
          <tr class="ticketRow" mat-row *matRowDef="let row; columns: columns;"
              (click)="editTicket(row.ticketNumber)"></tr>

          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="7">No tickets found.</td>
          </tr>

        </table>
        <mat-paginator [pageSizeOptions]="pageSizeOptions"></mat-paginator>
      </mat-card-content>
    </mat-card>
  </div>
</div>
